export default __webpack_public_path__ + "static/media/circle-check-regular.900b73e7.svg";